<template>
  <div>
    <v-card class="pa-3">
      <v-layout wrap class="form-control">
        <v-flex xs6 class="pt-1">
          <div class="primary--text">{{ $t('Advanced search') }}</div>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-btn flat icon @click="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">คำขอหมายเลข</div>
          <input v-model="filter.request_id" type="text" />
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">ชื่อศูนย์</div>
          <input v-model="filter.branch_name" type="text" />
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">ผู้อนุมัติ</div>
          <input v-model="filter.approve_by" type="text" />
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">สถานะคำขอ</div>
          <multiselect
            v-model="filter.status"
            :options="status"
            label="label"
            select-label
            selected-label
            track-by="value"
          ></multiselect>
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">ประเภทช่าง</div>
          <multiselect
            v-model="filter.user_type"
            :options="userType"
            label="label"
            select-label
            selected-label
            track-by="value"
          ></multiselect>
        </v-flex>
      </v-layout>
      <v-layout wrap class="form-control mt-2">
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">วันที่เข้า</div>
          <VueCtkDateTimePicker
            v-model="filter.start_time"
            color="#ff706b"
            locale="en"
            no-label
            no-clear-button
            :format="'YYYY-MM-DD HH:mm'"
            :formatted="'DD/MM/YYYY HH:mm'"
          />
        </v-flex>
        <v-flex xs12 sm6 mt-2 pr-2>
          <div class="caption">วันที่ออก</div>
          <VueCtkDateTimePicker
            v-model="filter.end_time"
            color="#ff706b"
            locale="en"
            no-label
            no-clear-button
            :format="'YYYY-MM-DD HH:mm'"
            :formatted="'DD/MM/YYYY HH:mm'"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap class="form-control">
        <v-flex xs12 class="pt-3">
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn color="primary" @click="onSearch">{{ $t('Search') }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import CustomTimepicker from '@/components/elements/CustomTimepicker'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import Multiselect from 'vue-multiselect'
const initialFilter = {
  request_id: '',
  branch_name: '',
  approve_by: '',
  status: '',
  user_type: '',
  start_time: null,
  end_time: null
}
export default {
  components: {
    Multiselect,
    CustomTimepicker,
    VueCtkDateTimePicker
  },
  data() {
    return {
      filter: { ...initialFilter },
      userType: [
        {
          label: 'พนักงาน',
          value: 'staff'
        },
        {
          label: 'บุคคลภายนอก',
          value: 'guest'
        }
      ],
      status: [
        {
          label: 'รอตรวจสอบข้อมูลช่าง',
          value: 'register'
        },
        {
          label: 'รอพิจารณา',
          value: 'pending'
        },
        {
          label: 'รอรหัส PIN',
          value: 'waiting'
        },
        {
          label: 'อนุมัติ',
          value: 'approve'
        },
        {
          label: 'ไม่อนุมัติ',
          value: 'reject'
        }
      ]
    }
  },
  methods: {
    clearSearch() {
      this.filter = { ...initialFilter }
      this.$emit('onSearch', this.filter)
    },
    onSearch() {
      const filter = {
        ...this.filter,
        user_type:
          this.filter.user_type && this.filter.user_type.value ? this.filter.user_type.value : null,
        status: this.filter.status && this.filter.status.value ? this.filter.status.value : null
      }
      this.$emit('onSearch', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.caption {
  font-size: 14px !important;
  margin-bottom: 12px;
}
input {
  max-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/SearchRequestDialog.vue